"use client";
import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null); // Tracks which dropdown is active

  const toggleDropdown = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index)); // Toggle logic
  };

  return (
    <section>
      <div
        className={`bg-[#222222] flex flex-col justify-center items-center w-full px-4 py-14`}
        id="faq"
      >
        {/* <div className="bg-[#F0F0F0] rounded-3xl w-full h-full lg:w-5/6 lg:h-5/6 py-14 px-4 sm:px-6 flex flex-col justify-center items-center"> */}
        {/* Section header */}
        <div className="w-full mx-auto text-center items-center flex flex-col">
          <div
            className={`bg-gradient-to-r from-gray-600 to-gray-800 inline-flex text-sm font-semibold py-1 px-3 m-2 text-white rounded-full mb-4 gap-x-2`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-message-circle-question-icon lucide-message-circle-question"
            >
              <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <path d="M12 17h.01" />
            </svg>
            Questions & Answers
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white w-full lg:w-60rem tracking-normal text-center">
            Frequently asked questions
          </h2>
        </div>

        {/* Accordion */}
        <div className="w-full xl:w-[1130px] mt-10 gap-y-6 text-gray-800 text-lg">
          <Accordion
            className="w-full flex flex-col gap-y-4"
            type="single"
            collapsible
          >
            <AccordionItem
              className="bg-white rounded-xl px-6 transition-all shadow-sm hover:shadow-md"
              value="item-1"
            >
              <AccordionTrigger className="text-left">
                What is NotifyAPI?{" "}
              </AccordionTrigger>
              <AccordionContent className="text-lg text-gray-500">
                <div>
                  <p>
                    NotifyAPI is a "set-and-forget" alert system designed for
                    busy owners who can’t spend all day staring at a dashboard.
                    Instead of checking five different apps to see if things are
                    running smoothly, you get a direct text message for the
                    things that actually matter, like a new high-value lead, a
                    low-stock warning, or a successful daily backup.
                    <br />
                    <br />
                    It’s built for simplicity: there are no complex "error logs"
                    to decode. You simply choose what you want to be notified
                    about, and NotifyAPI ensures that critical update finds you,
                    wherever you are.
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem
              className="bg-white rounded-xl px-6 transition-all shadow-sm hover:shadow-md"
              value="item-2"
            >
              <AccordionTrigger className="text-left">
                When can I use it?
              </AccordionTrigger>
              <AccordionContent className="text-lg text-gray-500">
                <div>
                  <p>
                    NotifyAPI is actively in development. If you're interested
                    in being one of the first to try it out, make sure to join
                    the waitlist.
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
        {/* </div> */}
      </div>
    </section>
  );
}
